import { render, staticRenderFns } from "./WidgetCards.vue?vue&type=template&id=12077cd2&scoped=true"
import script from "./WidgetCards.vue?vue&type=script&lang=js"
export * from "./WidgetCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12077cd2",
  null
  
)

export default component.exports